import React from "react";

import OnboardingTagSelectionScreen from "./Components/OnboardingTagSelectionScreen";

import type { AppUserSession } from "@/schemas/auth/session";
import { UserAttributeType } from "@/schemas/profile/UserAttributeSet";

type Props = {
  session: AppUserSession;
};

function OnboardingInterestsScreen({ session }: Props): React.JSX.Element {
  return (
    <OnboardingTagSelectionScreen
      session={session}
      userAttributeType={UserAttributeType.INTEREST}
      title="What are your interests?"
      description="Help others get to know you. Adding your interests makes it easier for people to find common ground and start a meaningful conversation."
    />
  );
}

export default OnboardingInterestsScreen;
